// NPM Imports
import React from "react";

// Component Imports
import DynamicFeildAttachWorkflow from "./DynamicFeildAttachWorkflow";
import DynamicFeildAttachWorkflowUpgrade from "./DynamicFeildAttachWorkflowUpgrade";
import { FeatureGating } from "../../../../commonComponents";

// Internal Imports
import { FEATURES } from "../../../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function(props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.WF_STANDARD_VARIABLES}
      altComponent={
        <DynamicFeildAttachWorkflowUpgrade
          featureName={FEATURES_NAME.WF_STANDARD_VARIABLES}
          {...props}
        />
      }>
      <DynamicFeildAttachWorkflow {...props} />
    </FeatureGating>
  );
}



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFeildAttachWorkflow/index.js